import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {Link} from '../link/link';

import {TwoLine} from './two-line';

import styles from './two-line-mini-card.module.css';

type Props = {
    icon?: React.ComponentType<any>;
    iconSize?: number;
    iconColor?: string;
    topRow: string | React.ReactNode;
    bottomRow?: string | React.ReactNode;
    isGrey?: boolean;
    isThumbnail?: boolean;
    to?: string;
    onClick?: () => void;
    borderColor?: string;
    width?: number;
};

/**
 * This is a way to display the TwoLine shell on a mini card, optionally wrapped
 * in a Link to make it clickable. Currently used in DripSequencePreview and in
 * ConnectedFormsPreview.
 */
export function TwoLineMiniCard(props: Props) {
    const content = (
        <TwoLine
            icon={props.icon}
            iconSize={props.iconSize}
            iconColor={props.iconColor}
            topRow={props.topRow}
            bottomRow={props.bottomRow}
            // @ts-expect-error
            isGrey={props.isGrey}
            isLargeWithSmallBottomRow={true}
            hasBoldTopRow={true}
            shouldCenterSingleLine={true}
        />
    );

    const styleName = classnames(styles.container, {
        [styles['container--grey']]: props.isGrey,
        [styles['container--no-hover']]: !props.onClick && !props.to,
        [styles['container--with-shadow']]: props.onClick && !props.isGrey,
    });

    return (
        <div
            style={{borderColor: props.borderColor, minWidth: props.width, width: props.width}}
            className={styleName}
        >
            <div className={styles['inner-container']}>
                {!props.isThumbnail && props.to ? (
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        to={props.to}
                        onClick={props.onClick}
                        preventUnderline={true}
                    >
                        {content}
                    </Link>
                ) : (
                    <div onClick={props.onClick}>{content}</div>
                )}
            </div>
        </div>
    );
}
